import './system/yup'

import { AppProvider } from '@festina-life/components'
// It's important to import from the core index module to ensure that DayJS initializations are correctly done
import { objectUtils } from '@festina-life/core'
import { FestinaLogo, FestinaLogoDarkMode } from '@festina-life/ui/icons'
import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'

import { registerFPlusDiffHighlighting } from './components/fplusDiff/fplusDiffHighlighting'
import { ConfigurationProvider } from './context/ConfigurationProvider'
import { buildInfo } from './system/buildInfo'
import { Router } from './system/Router'
import { translations } from './translations/translations'
import { OpenApiConfigurations } from './uiModels/openApiServices'

const mergedOpenApiSpec = objectUtils.mergeObjects(OpenApiConfigurations)

registerFPlusDiffHighlighting()

const root = createRoot(document.getElementById('root') as Element)
root.render(
  <StrictMode>
    <AppProvider
      build={buildInfo}
      i18nMessages={translations}
      openApi={mergedOpenApiSpec}
      images={{
        dark: FestinaLogoDarkMode,
        light: FestinaLogo,
      }}
      currency="EUR"
      defaultLanguage="en-GB"
      shouldShowTimeSettings={false}
      devToolsClassName="right-40!"
    >
      <ConfigurationProvider>
        <Suspense>
          <Router />
        </Suspense>
      </ConfigurationProvider>
    </AppProvider>
  </StrictMode>,
)
